import styled from 'styled-components';

export const Wrapper = styled.div`
  column-gap: 20px;
  align-items: center;
  grid-template-columns: repeat(2, 1fr) auto;
  grid-auto-flow: column;
  display: grid;
`;

export const Field = styled.div`
  position: relative;
  
  &:first-child:after {
    content: "";
    
    position: absolute;
    margin: auto;
    right: -20px;
    top: 0;
    bottom: 0;
    
    display: grid;
    height: 1px;
    width: 20px;
    
    background: ${({theme}) => `
      ${theme.variables.borderColor};
    `};
  }
`;

export const Controls = styled.div`
  grid-auto-flow: column;
  display: inline-grid;
`;
